import { Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { COUNTRIES, SERVER_URL } from '../Constants';
import {
  set_top_rated_stadiums,
  set_selected_city_areas,
  set_selected_country,
  set_selected_location,
} from '../redux/MalaebSlice/malaeb';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';
import Locale from '../translations';
import { useEffect, useRef, useState } from 'react';
import analytics, { AnalyticsKeys } from 'Analytics/analytics';

export default function Header(props) {
  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const headerRef = useRef(null);
  const history = useHistory()
  const { messages, events } = Locale;
  const dispatch = useDispatch();
  const pathname = props.location?.pathname;
  const { country: selected_country, user_uuid } = useSelector(
    (state) => state.malaeb)

  const { locale } = useSelector(
    (state) => state.malaeb
  );

  async function getCurrentCountry() {
    try {
      const response = await fetch(
        'https://ipgeolocation.abstractapi.com/v1/?api_key=d8534255d6ca4663b6d23f0cc64bc07a'
      )
      const result = await response.json();
      let country_detected =
        COUNTRIES.find((item) => item.code == data.country_code) ||
        COUNTRIES[0];
      dispatch(dispatch(set_selected_country(country_detected)));
    }
    catch (error) { dispatch(set_selected_country(COUNTRIES[0])) }
  }

  useEffect(() => {
    if (!selected_country) {
      getCurrentCountry();

    }
  }, [selected_country]);

  // handle scroll event
  const handleScroll = (elTopOffset, elHeight) => {
    if (window.pageYOffset > elTopOffset + elHeight) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };

  function change_selected_country(evt, country) {
    dispatch(set_selected_location({}));
    dispatch(set_selected_city_areas([]));
    dispatch(set_selected_country(country));
    setTimeout(() => {
      window.$('#CITY').val('');
    }, 500);

    console.log('cc', country)
  }

  // add/remove scroll event listener
  useEffect(() => {
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height);
    };

    window.addEventListener('scroll', handleScrollEvent);

    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, []);

  return (
    <header
      className={`header ${sticky.isSticky ? 'sticky' : ''}`}
      ref={headerRef}
    >
      <nav className="navbar editNavbar navbar-expand-lg navbar-light">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img
              src="./images/logo.png"
              alt="imageLogo"
              className="img-fluid"
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className="collapse navbar-collapse pt-xl-0"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle ps-2"
                  href="/#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={`./images/flags/${selected_country.code}.svg`}
                    className="ps-2 mr-1"
                    width="30"
                    alt="img"
                  />{' '}
                  {locale === 'en'
                    ? selected_country.name
                    : selected_country.name_ar}
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  {COUNTRIES.map((item) => (
                    <li key={item.code}>
                      <a
                        className="dropdown-item"
                        href="/#"
                        onClick={(evt) => change_selected_country(evt, item)}
                      >
                        <img
                          src={`./images/flags/${item.code}.svg`}
                          width="30"
                          className="m-2"
                          alt="img"
                        />{' '}
                        {locale === 'en' ? item.name : item.name_ar}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item me-lg-3">
                <Link
                  to="/"
                  className={`nav-link ${pathname === '/' ? 'active' : ''}`}
                >
                  {messages.home}
                </Link>
              </li>
              <li className="nav-item me-lg-3">
                <Link
                  to="/list"
                  className={`nav-link ${pathname === '/list' ? 'active' : ''}`}
                >
                  {messages.spaces}
                </Link>
              </li>
              <li className="nav-item me-lg-3">
                <Link
                  to="/about"
                  className={`nav-link ${pathname === '/about' ? 'active' : ''}`}
                >
                  {messages.aboutUs}
                </Link>
              </li>
              <li className="nav-item me-lg-3">
                <Link
                  to="/contact-us"
                  className={`nav-link ${pathname === '/contact-us' ? 'active' : ''}`}
                >
                  {messages.contactUs}
                </Link>

              </li>
              <li className="nav-item me-lg-3">
                <Link
                  to="/events"
                  className={`nav-link ${pathname === '/events' ? 'active' : ''}`}
                >
                  {events.event}
                </Link>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item cursor-pointer">
                <a
                  className="nav-link textGreen"
                  target="_self"
                  onClick={() =>{
                    analytics.log(AnalyticsKeys.ForStadiumOwner)
                    history?.push("typeForm")
                  }}
                  rel="noreferrer"
                >
                  {messages.stadiumOwners}
                </a>
              </li>
              <li className="nav-item">
                <LanguageSwitcher />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
